import { startCase, isArray, isString, isNumber, isBoolean, isEmpty, isObject } from 'lodash'
import humanize from 'humanize-number'

export {
  humanizeKey,
  parseValue
}

function humanizeKey (key) {
  return startCase(key)
    .replace('Mtu', 'MTU')
    .replace('Mrr', 'MRR')
    .replace('Csm', 'CSM')
    .replace('Ae', 'AE')
    .replace('30 D', 'Month')
}

function parseValue (value) {
  if (isArray(value)) return value.map(v => parseValue(v)).join(', ')
  if (isString(value)) return value
  if (isNumber(value)) return humanize(value)
  if (isBoolean(value)) return Boolean(value).toString()
  if (isEmpty(value)) return ''
  if (isObject(value)) return JSON.stringify(value)
  return typeof value
}



// WEBPACK FOOTER //
// ./lib/transform-record.js